import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "forward-header__text" }
const _hoisted_2 = { class: "forward-header__icon-container" }
const _hoisted_3 = { class: "forward-header__subtitle" }
const _hoisted_4 = { class: "forward-body" }
const _hoisted_5 = { class: "forward-body__search" }
const _hoisted_6 = { class: "forward-body__conversations" }
const _hoisted_7 = {
  key: 0,
  class: "forward-body__loading"
}
const _hoisted_8 = {
  key: 1,
  class: "forward-body__empty"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "forward-body__item-content" }
const _hoisted_14 = { class: "forward-body__item-header" }
const _hoisted_15 = { class: "forward-body__item-name" }
const _hoisted_16 = { class: "forward-body__item-time" }
const _hoisted_17 = { class: "forward-body__item-preview" }
const _hoisted_18 = { class: "forward-body__item-message" }
const _hoisted_19 = {
  key: 1,
  class: "forward-body__loading-more"
}

import { Button, Icon, Modal } from "@/components/ui";
import type { Conversation } from "@/dtos/Unipile.dto";
import { computed, ref, watch } from "vue";

interface Props {
  show: boolean;
  conversations: Conversation[];
  channelType?: string;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  hasMore?: boolean;
  isForwarding?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ForwardMessageModal',
  props: {
    show: { type: Boolean },
    conversations: {},
    channelType: {},
    isLoading: { type: Boolean, default: false },
    isLoadingMore: { type: Boolean, default: false },
    hasMore: { type: Boolean, default: false },
    isForwarding: { type: Boolean, default: false }
  },
  emits: ["close", "forward", "search", "load-more"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchQuery = ref("");
const selectedConversationId = ref<string | null>(null);

const filteredConversations = computed(() => {
  if (!searchQuery.value.trim()) {
    return props.conversations;
  }
  const query = searchQuery.value.toLowerCase().trim();
  return props.conversations.filter((conv) => {
    const name = (conv.contactName || "").toLowerCase();
    const message = (conv.lastMessage || "").toLowerCase();
    return name.includes(query) || message.includes(query);
  });
});

watch(searchQuery, (newQuery) => {
  emit("search", newQuery);
});

watch(
  () => props.show,
  (isOpen) => {
    if (!isOpen) {
      selectedConversationId.value = null;
      searchQuery.value = "";
    }
  }
);

const handleSelect = (conversation: Conversation) => {
  selectedConversationId.value = conversation.id;
};

const handleForward = () => {
  if (selectedConversationId.value) {
    emit("forward", selectedConversationId.value);
  }
};

const handleSearch = () => {
  // Search is handled by watch
};

const handleScroll = (event: Event) => {
  const target = event.target as HTMLElement;
  const distanceToBottom = target.scrollHeight - (target.scrollTop + target.clientHeight);
  if (distanceToBottom < 100 && props.hasMore && !props.isLoadingMore && !props.isLoading) {
    emit("load-more");
  }
};

const handleLoadMore = () => {
  if (props.hasMore && !props.isLoadingMore && !props.isLoading) {
    emit("load-more");
  }
};

const formatTime = (timestamp?: string): string => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    show: __props.show,
    title: "Forward Message",
    headerVariant: "blue",
    size: "md",
    dialogMaxWidth: "600px",
    closeOnBackdrop: true,
    blurBackdrop: false,
    backdropOpacity: 0.5,
    "show-close-button": false,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Icon), {
            icon: "mdi:share-variant",
            class: "forward-header__icon"
          })
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "forward-header__title" }, "Forward Message", -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.channelType === "whatsapp"
                ? "Select a WhatsApp conversation to forward this message to"
                : "Select a conversation to forward this message to"), 1)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "forward-header__close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        "aria-label": "Close"
      }, [
        _createVNode(_unref(Icon), {
          icon: "mdi:close",
          width: "18",
          height: "18"
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Icon), {
            icon: "mdi:magnify",
            class: "forward-body__search-icon"
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: "Search conversations...",
            class: "forward-body__search-input",
            onInput: handleSearch
          }, null, 544), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (__props.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:loading",
                  class: "forward-body__loading-icon"
                }),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "Loading conversations...", -1))
              ]))
            : (filteredConversations.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:message-outline",
                    class: "forward-body__empty-icon"
                  }),
                  (searchQuery.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "No conversations found"))
                    : (__props.channelType !== 'whatsapp')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Forwarding is only available for WhatsApp messages "))
                      : (_openBlock(), _createElementBlock("p", _hoisted_11, "No WhatsApp conversations available"))
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "forward-body__list",
                  onScroll: handleScroll
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredConversations.value, (conversation) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: conversation.id,
                      class: _normalizeClass(["forward-body__item", {
                'forward-body__item--selected': selectedConversationId.value === conversation.id,
              }]),
                      onClick: ($event: any) => (handleSelect(conversation))
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(conversation.contactName || "Unknown"), 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(formatTime(conversation.lastMessageAt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(conversation.lastMessage || "No messages"), 1)
                        ])
                      ])
                    ], 10, _hoisted_12))
                  }), 128)),
                  (__props.hasMore && !__props.isLoadingMore)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "forward-body__load-more",
                        onClick: handleLoadMore
                      }, " Load more conversations "))
                    : _createCommentVNode("", true),
                  (__props.isLoadingMore)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_unref(Icon), {
                          icon: "mdi:loading",
                          class: "forward-body__loading-icon"
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("p", null, "Loading more...", -1))
                      ]))
                    : _createCommentVNode("", true)
                ], 32))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        variant: "secondary",
        size: "md",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
        disabled: __props.isForwarding
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode(" Cancel ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(Button), {
        variant: "primary",
        size: "md",
        icon: "mdi:share-variant",
        "icon-position": "left",
        loading: __props.isForwarding,
        disabled: !selectedConversationId.value || __props.isForwarding,
        onClick: handleForward
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode(" Forward ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})